@if (tabsContent$ | async; as tabsContent) {
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
    [destroyOnHide]="false"
    >
    @if (this.form.controls['isCompany'].value) {
      <li [ngbNavItem]="0">
        <button ngbNavLink class="nav-link" translate>
          CONTACT_TABS_CONTACTS
        </button>
        <ng-template ngbNavContent>
          <app-contact-details-children />
        </ng-template>
      </li>
    }
    <!--    <li [ngbNavItem]="tabContent.index"-->
    <!--        *ngFor="let tabContent of tabsContent; count as count; last as isLast; trackBy: trackByTabsContent">-->
    <!--      <button ngbNavLink class="nav-link" translate>-->
    <!--        {{ tabContent.title }}-->
    <!--        <ng-container-->
    <!--          *ngIf="tabContent.formGroupName && this.form.controls[tabContent.formGroupName]?.touched && this.form.controls[tabContent.formGroupName]?.invalid">-->
    <!--          <span class="ps-1">-->
    <!--            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">-->
    <!--              <ng-container *ngFor="let error of errors.children">-->
    <!--                <span class="badge text-bg-danger"-->
  <!--                      *ngIf="error.groupName === tabContent.formGroupName">{{ error.count }}</span>-->
<!--              </ng-container>-->
<!--            </ng-container>-->
<!--            <ng-template #noError>-->
<!--              <span class="dot"></span>-->
<!--            </ng-template>-->
<!--          </span>-->
<!--        </ng-container>-->
<!--      </button>-->
<!--      <ng-template ngbNavContent>-->
<!--        <ng-container *ngComponentOutlet="tabContent.component"/>-->
<!--      </ng-template>-->
<!--    </li>-->
<li [ngbNavItem]="1">
  <button ngbNavLink class="nav-link" translate>
    CONTACT_TABS_MARKETING
    @if (!!this.form.controls['marketingFormGroup'] && this.form.controls['marketingFormGroup']?.touched && this.form.controls['marketingFormGroup']?.invalid) {
      <span class="ps-1">
        @if (errorsDescription$ | async; as errors) {
          @for (error of errors.children; track error) {
            @if (error.groupName === 'marketingFormGroup') {
              <span class="badge text-bg-danger"
              >{{ error.count }}</span>
            }
          }
        } @else {
          <span class="dot"></span>
        }
      </span>
    }
  </button>
  <ng-template ngbNavContent>
    <app-contact-form-marketing/>
  </ng-template>
</li>
<!--    <li [ngbNavItem]="2">-->
<!--      <button ngbNavLink class="nav-link" translate>-->
<!--        CONTACT_TABS_NOTES-->
<!--        <ng-container-->
<!--          *ngIf="!!this.form.controls['notesFormGroup'] && this.form.controls['notesFormGroup']?.touched && this.form.controls['notesFormGroup']?.invalid">-->
<!--          <span class="ps-1">-->
<!--            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">-->
<!--              <ng-container *ngFor="let error of errors.children">-->
<!--                <span class="badge text-bg-danger"-->
<!--                      *ngIf="error.groupName === 'notesFormGroup'">{{ error.count }}</span>-->
<!--              </ng-container>-->
<!--            </ng-container>-->
<!--            <ng-template #noError>-->
<!--              <span class="dot"></span>-->
<!--            </ng-template>-->
<!--          </span>-->
<!--        </ng-container>-->
<!--      </button>-->
<!--      <ng-template ngbNavContent>-->
<!--        <app-contact-form-notes />-->
<!--      </ng-template>-->
<!--    </li>-->
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
}
